<template>
	<div class="news-list-container">
		<!-- 列表页 -->
		<template v-if="showFlag">
			<!-- 页面头部 -->
			<div class="page-header">
				<div class="header-content">
					<div class="header-icon">
						<svg class="icon" viewBox="0 0 24 24">
							<path d="M19,5V7H15V5H19M9,5V11H5V5H9M19,13V19H15V13H19M9,17V19H5V17H9M21,3H13V9H21V3M11,3H3V13H11V3M21,11H13V21H21V11M11,15H3V21H11V15Z"/>
						</svg>
					</div>
					<div class="header-text">
						<h1 class="page-title">新闻资讯管理</h1>
						<p class="page-description">发布和管理网站新闻资讯内容</p>
					</div>
					<div class="header-actions">
						<el-button 
							v-if="isAuth('news','新增')" 
							type="primary" 
							icon="el-icon-plus"
							@click="addOrUpdateHandler()"
							class="add-btn"
						>
							发布新闻
						</el-button>
					</div>
				</div>
			</div>

			<!-- 筛选区域 -->
			<div class="filter-section">
				<el-card shadow="never" class="filter-card">
					<el-form :inline="true" :model="searchForm" class="search-form">
						<div class="filter-group">
							<div class="filter-item">
								<label class="filter-label">新闻标题</label>
								<el-input 
									v-model="searchForm.title" 
									placeholder="请输入新闻标题" 
									clearable
									class="filter-input"
								></el-input>
							</div>
						</div>
						<div class="filter-actions">
							<el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
							<el-button icon="el-icon-refresh" @click="resetSearch()">重置</el-button>
						</div>
					</el-form>
				</el-card>
			</div>

			<!-- 工具栏 -->
			<div class="toolbar-section" v-show="dataListSelections.length > 0">
				<div class="toolbar-content">
					<div class="selected-info">
						<span>已选择 {{ dataListSelections.length }} 条记录</span>
					</div>
					<div class="batch-actions">
						<el-button 
							v-if="isAuth('news','删除')" 
							type="danger" 
							icon="el-icon-delete"
							@click="deleteHandler()"
							:disabled="dataListSelections.length <= 0"
						>
							批量删除
						</el-button>
					</div>
				</div>
			</div>

			<!-- 数据表格 -->
			<div class="table-section">
				<el-card shadow="never" class="table-card">
					<el-table 
						class="data-table"
						v-if="isAuth('news','查看')"
						:data="dataList"
						v-loading="dataListLoading"
						@selection-change="selectionChangeHandler"
						empty-text="暂无新闻数据"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column 
							type="selection" 
							width="55" 
							align="center"
						></el-table-column>
						
						<el-table-column 
							label="序号" 
							type="index" 
							width="70" 
							align="center"
							:index="getTableIndex"
						></el-table-column>
						
						<el-table-column 
							prop="title"
							label="新闻标题"
							min-width="250"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="news-title">
									<div class="news-icon">
										<svg viewBox="0 0 24 24">
											<path d="M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V3L20.33,4.67Z"/>
										</svg>
									</div>
									<div class="news-info">
										<div class="news-main-title">{{ scope.row.title }}</div>
										<div class="news-date" v-if="scope.row.addtime">
											发布时间：{{ formatDate(scope.row.addtime) }}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="新闻图片" 
							width="100" 
							align="center"
						>
							<template slot-scope="scope">
								<div class="news-image">
									<div class="image-preview" v-if="scope.row.picture">
										<img 
											v-if="scope.row.picture.substring(0,4)=='http'" 
											:src="scope.row.picture.split(',')[0]" 
											class="news-img"
											@error="handleImageError"
											@click="previewImage(scope.row.picture.split(',')[0])"
										>
										<img 
											v-else 
											:src="$base.url+scope.row.picture.split(',')[0]" 
											class="news-img"
											@error="handleImageError"
											@click="previewImage($base.url+scope.row.picture.split(',')[0])"
										>
										<div class="image-overlay">
											<i class="el-icon-zoom-in"></i>
										</div>
									</div>
									<div class="no-image" v-else>
										<i class="el-icon-picture-outline"></i>
										<span>暂无图片</span>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="简介预览" 
							width="200" 
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="news-intro">
									{{ getIntroPreview(scope.row.introduction) }}
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="发布状态" 
							width="90" 
							align="center"
						>
							<template>
								<el-tag 
									type="success" 
									size="small"
									class="status-tag"
								>
									已发布
								</el-tag>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="操作" 
							width="240" 
							align="center"
							fixed="right"
						>
							<template slot-scope="scope">
								<div class="action-buttons">
									<el-button 
										v-if="isAuth('news','查看')" 
										type="info" 
										size="mini" 
										icon="el-icon-view"
										@click="addOrUpdateHandler(scope.row.id, 'info')"
										class="action-btn view-btn"
									>
										详情
									</el-button>
									<el-button 
										v-if="isAuth('news','修改')" 
										type="primary" 
										size="mini" 
										icon="el-icon-edit"
										@click="addOrUpdateHandler(scope.row.id)"
										class="action-btn edit-btn"
									>
										编辑
									</el-button>
									<el-button 
										v-if="isAuth('news','删除')" 
										type="danger" 
										size="mini" 
										icon="el-icon-delete"
										@click="deleteHandler(scope.row.id)"
										class="action-btn delete-btn"
									>
										删除
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</div>

			<!-- 分页 -->
			<div class="pagination-section">
				<el-pagination
					@size-change="sizeChangeHandle"
					@current-change="currentChangeHandle"
					:current-page="pageIndex"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalPage"
					class="data-pagination"
				></el-pagination>
			</div>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>

		<!-- 图片预览对话框 -->
		<el-dialog
			:visible.sync="previewVisible"
			title="图片预览"
			width="60%"
			class="preview-dialog"
		>
			<div class="image-preview-container">
				<img :src="previewImageUrl" class="preview-image" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        title: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      chartVisiable1: false,
      chartVisiable2: false,
      chartVisiable3: false,
      chartVisiable4: false,
      chartVisiable5: false,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],
      previewVisible: false,
      previewImageUrl: '',

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {

    contentStyleChange() {
      this.contentPageStyleChange()
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      // if(this.contents.pageTotal) arr.push('total')
      // if(this.contents.pageSizes) arr.push('sizes')
      // if(this.contents.pagePrevNext){
      //   arr.push('prev')
      //   if(this.contents.pagePager) arr.push('pager')
      //   arr.push('next')
      // }
      // if(this.contents.pageJumper) arr.push('jumper')
      // this.layouts = arr.join()
      // this.contents.pageEachNum = 10
    },








    init () {
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    resetSearch() {
      this.searchForm = {
        title: ''
      };
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
           if(this.searchForm.title!='' && this.searchForm.title!=undefined){
            params['title'] = '%' + this.searchForm.title + '%'
          }
      this.$http({
        url: "news/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "news/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 获取表格序号
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 获取简介预览
    getIntroPreview(intro) {
      if (!intro) return '';
      const preview = intro.substring(0, 100); // 截取前100个字符
      return preview + (intro.length > 100 ? '...' : '');
    },
         // 处理图片加载失败
     handleImageError(event) {
       event.target.style.display = 'none';
     },
    // 预览图片
    previewImage(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    }

  }

};
</script>
<style lang="scss" scoped>
	
	.center-form-pv {
	  .el-date-editor.el-input {
	    width: auto;
	  }
	}
	
	.el-input {
	  width: auto;
	}
	
	// form
	.center-form-pv .el-input /deep/ .el-input__inner {
				border: 2px solid #B8DE4A;
				border-radius: 4px;
				padding: 0 12px;
				outline: none;
				color: rgba(0, 0, 0, 1);
				width: 150px;
				font-size: 14px;
				height: 40px;
			}
	
	.center-form-pv .el-select /deep/ .el-input__inner {
				border: 2px solid #B8DE4A;
				border-radius: 4px;
				padding: 0 10px;
				outline: none;
				color: rgba(0, 0, 0, 1);
				width: 150px;
				font-size: 14px;
				height: 40px;
			}
	
	.center-form-pv .el-date-editor /deep/ .el-input__inner {
				border: 2px solid #B8DE4A;
				border-radius: 4px;
				padding: 0 10px 0 30px;
				outline: none;
				color: rgba(0, 0, 0, 1);
				width: 150px;
				font-size: 14px;
				height: 40px;
			}
	
	// table
	.el-table /deep/ .el-table__header-wrapper thead {
				color: #333;
				font-weight: 500;
				width: 100%;
			}
	
	.el-table /deep/ .el-table__header-wrapper thead tr {
				background: #fff;
			}
	
	.el-table /deep/ .el-table__header-wrapper thead tr th {
				padding: 12px 0;
				background: rgba(226, 226, 226, 1);
				border-color: #eee;
				border-width: 0 1px 1px 0;
				border-style: solid;
				text-align: center;
			}

	.el-table /deep/ .el-table__header-wrapper thead tr th .cell {
				padding: 0 10px;
				word-wrap: normal;
				word-break: break-all;
				white-space: normal;
				font-weight: bold;
				display: inline-block;
				vertical-align: middle;
				width: 100%;
				line-height: 24px;
				position: relative;
				text-overflow: ellipsis;
			}

	
	.el-table /deep/ .el-table__body-wrapper tbody {
				width: 100%;
			}

	.el-table /deep/ .el-table__body-wrapper tbody tr {
				background: #fff;
			}
	
	.el-table /deep/ .el-table__body-wrapper tbody tr td {
				padding: 6px 0;
				color: #999;
				background: #fff;
				border-color: #eee;
				border-width: 0 1px 1px 0;
				border-style: solid;
				text-align: center;
			}
	
		
	.el-table /deep/ .el-table__body-wrapper tbody tr:hover td {
				padding: 6px 0;
				color: #333;
				background: rgba(226, 226, 226, .2);
				border-color: #eee;
				border-width: 0 1px 1px 0;
				border-style: solid;
				text-align: center;
			}
	
	.el-table /deep/ .el-table__body-wrapper tbody tr td {
				padding: 6px 0;
				color: #999;
				background: #fff;
				border-color: #eee;
				border-width: 0 1px 1px 0;
				border-style: solid;
				text-align: center;
			}

	.el-table /deep/ .el-table__body-wrapper tbody tr td .cell {
				padding: 0 10px;
				overflow: hidden;
				word-break: break-all;
				white-space: normal;
				line-height: 24px;
				text-overflow: ellipsis;
			}
	
	// pagination
	.main-content .el-pagination /deep/ .el-pagination__total {
				margin: 0 10px 0 0;
				color: #666;
				font-weight: 400;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .btn-prev {
				border: none;
				border-radius: 2px;
				padding: 0;
				margin: 0 5px;
				color: #666;
				background: #f4f4f5;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				min-width: 35px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .btn-next {
				border: none;
				border-radius: 2px;
				padding: 0;
				margin: 0 5px;
				color: #666;
				background: #f4f4f5;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				min-width: 35px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .btn-prev:disabled {
				border: none;
				cursor: not-allowed;
				border-radius: 2px;
				padding: 0;
				margin: 0 5px;
				color: #C0C4CC;
				background: #f4f4f5;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .btn-next:disabled {
				border: none;
				cursor: not-allowed;
				border-radius: 2px;
				padding: 0;
				margin: 0 5px;
				color: #C0C4CC;
				background: #f4f4f5;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				height: 28px;
			}

	.main-content .el-pagination /deep/ .el-pager {
				padding: 0;
				margin: 0;
				display: inline-block;
				vertical-align: top;
			}

	.main-content .el-pagination /deep/ .el-pager .number {
				cursor: pointer;
				padding: 0 4px;
				margin: 0 5px;
				color: #666;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				border-radius: 2px;
				background: #f4f4f5;
				text-align: center;
				min-width: 30px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pager .number:hover {
				cursor: pointer;
				padding: 0 4px;
				margin: 0 5px;
				color: #b8de4a;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				border-radius: 2px;
				background: #f4f4f5;
				text-align: center;
				min-width: 30px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pager .number.active {
				cursor: default;
				padding: 0 4px;
				margin: 0 5px;
				color: #FFF;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				border-radius: 2px;
				background: #b8de4a;
				text-align: center;
				min-width: 30px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__sizes {
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__sizes .el-input {
				margin: 0 5px;
				width: 100px;
				position: relative;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__sizes .el-input .el-input__inner {
				border: 1px solid #DCDFE6;
				cursor: pointer;
				padding: 0 25px 0 8px;
				color: #606266;
				display: inline-block;
				font-size: 13px;
				line-height: 28px;
				border-radius: 3px;
				outline: 0;
				background: #FFF;
				width: 100%;
				text-align: center;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__sizes .el-input span.el-input__suffix {
				top: 0;
				position: absolute;
				right: 0;
				height: 100%;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__sizes .el-input .el-input__suffix .el-select__caret {
				cursor: pointer;
				color: #C0C4CC;
				width: 25px;
				font-size: 14px;
				line-height: 28px;
				text-align: center;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__jump {
				margin: 0 0 0 24px;
				color: #606266;
				display: inline-block;
				vertical-align: top;
				font-size: 13px;
				line-height: 28px;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__jump .el-input {
				border-radius: 3px;
				padding: 0 2px;
				margin: 0 2px;
				display: inline-block;
				width: 50px;
				font-size: 14px;
				line-height: 18px;
				position: relative;
				text-align: center;
				height: 28px;
			}
	
	.main-content .el-pagination /deep/ .el-pagination__jump .el-input .el-input__inner {
				border: 1px solid #DCDFE6;
				cursor: pointer;
				padding: 0 3px;
				color: #606266;
				display: inline-block;
				font-size: 14px;
				line-height: 28px;
				border-radius: 3px;
				outline: 0;
				background: #FFF;
				width: 100%;
				text-align: center;
				height: 28px;
			}

	.news-list-container {
		padding: 20px 3%;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.page-header {
		display: flex;
		align-items: center;
		padding: 20px 0;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
	}

	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	.header-icon {
		margin-right: 15px;
		color: #409EFF;
	}

	.header-text {
		flex-grow: 1;
	}

	.page-title {
		font-size: 24px;
		font-weight: bold;
		color: #333;
		margin-bottom: 5px;
	}

	.page-description {
		font-size: 14px;
		color: #666;
	}

	.header-actions {
		margin-left: 20px;
	}

	.add-btn {
		background-color: #409EFF;
		border-color: #409EFF;
	}

	.filter-section {
		margin-bottom: 20px;
	}

	.filter-card {
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.search-form {
		padding: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.filter-group {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 20px;
	}

	.filter-item {
		display: flex;
		align-items: center;
	}

	.filter-label {
		margin-right: 10px;
		color: #666;
		font-size: 14px;
	}

	.filter-input {
		width: 250px;
	}

	.filter-actions {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.toolbar-section {
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
		padding: 15px 20px;
	}

	.toolbar-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.selected-info {
		color: #666;
		font-size: 14px;
	}

	.batch-actions {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.table-section {
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
	}

	.table-card {
		padding: 20px;
	}

	.data-table {
		width: 100%;
	}

	.news-title {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.news-icon {
		margin-right: 10px;
		color: #409EFF;
	}

	.news-info {
		flex-grow: 1;
	}

	.news-main-title {
		font-size: 16px;
		font-weight: bold;
		color: #333;
		margin-bottom: 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.news-date {
		font-size: 12px;
		color: #999;
	}

	.news-image {
		position: relative;
		width: 80px;
		height: 60px;
		overflow: hidden;
		border-radius: 4px;
		border: 1px solid #eee;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f9f9f9;
	}

	.news-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.image-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity 0.3s ease;
		border-radius: 4px;
	}

	.image-preview:hover .image-overlay {
		opacity: 1;
	}

	.image-overlay i {
		color: #fff;
		font-size: 24px;
	}

						.no-image {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						color: #999;
						font-size: 12px;
					}

					.no-image i {
					font-size: 24px;
					margin-bottom: 4px;
				}

	.news-intro {
		font-size: 14px;
		color: #666;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.status-tag {
		background-color: #e1f3d8;
		color: #67c23a;
	}

	.action-buttons {
		display: flex;
		justify-content: center;
		gap: 10px;
	}

	.action-btn {
		padding: 5px 10px;
	}

	.action-btn.view-btn {
		background-color: #67c23a;
		border-color: #67c23a;
	}

	.action-btn.edit-btn {
		background-color: #409EFF;
		border-color: #409EFF;
	}

	.action-btn.delete-btn {
		background-color: #f56c6c;
		border-color: #f56c6c;
	}

	.pagination-section {
		text-align: right;
		padding-top: 20px;
	}

	.data-pagination {
		display: inline-block;
	}

	.preview-dialog {
		.el-dialog__header {
			background-color: #f5f7fa;
			border-bottom: 1px solid #ebeef5;
			padding: 15px 20px;
		}
		.el-dialog__title {
			font-size: 18px;
			font-weight: bold;
			color: #333;
		}
		.el-dialog__body {
			padding: 20px;
			text-align: center;
		}
		.preview-image-container {
			max-width: 100%;
			max-height: 80vh;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.preview-image {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}
	}
</style>
